/* eslint-disable camelcase */
import moment from '@/app/shared/plugins/Moment'

const API_DATE_FORMAT = 'YYYY-MM-DD'
const DISPLAY_DATE_FORMAT = 'DD-MM-YYYY'

// Chilean SII document types. An unmapped code is shown as-is instead of
// hiding it, so a new document type never renders an empty cell.
const DTE_TYPE_NAMES = {
  33: 'Factura',
  34: 'Factura exenta',
  39: 'Boleta',
  41: 'Boleta exenta',
  43: 'Liquidación factura',
  46: 'Factura de compra',
  52: 'Guía de despacho',
  56: 'Nota de débito',
  61: 'Nota de crédito'
}

// Overdue thresholds, in days, used to highlight the worst invoices.
const SEVERE_DAYS_OVERDUE = 90
const HIGH_DAYS_OVERDUE = 30

export default class OverdueInvoice {
  constructor (data) {
    this.id = data.id
    this.dteType = data.dte_type
    this.folio = data.folio
    this.clientName = data.client_name
    this.clientRut = data.client_rut
    this.issuedAt = data.issued_at
    this.dueAt = data.due_at
    this.currency = data.currency
    this.totalAmount = data.total_amount
    this.pendingAmount = data.pending_amount
    this.daysOverdue = data.days_overdue
    this.status = data.status
    this.note = data.note
  }

  get dteTypeName () {
    return DTE_TYPE_NAMES[this.dteType] || `Tipo ${this.dteType}`
  }

  get formattedIssuedAt () {
    return this.formatDate(this.issuedAt)
  }

  get formattedDueAt () {
    return this.formatDate(this.dueAt)
  }

  get daysOverdueClass () {
    if (this.daysOverdue >= SEVERE_DAYS_OVERDUE) return 'days-badge-severe'
    if (this.daysOverdue >= HIGH_DAYS_OVERDUE) return 'days-badge-high'
    return 'days-badge-moderate'
  }

  formatDate (value) {
    if (!value) return '-'
    // Parsed with an explicit format so the date is not shifted by the
    // browser timezone: the API returns a plain calendar date.
    const date = moment(value, API_DATE_FORMAT)
    return date.isValid() ? date.format(DISPLAY_DATE_FORMAT) : '-'
  }

  static fromArray (data) {
    return (data || []).map(item => new OverdueInvoice(item))
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/OverdueInvoice.js